const testimonials = [
  {
    quote: "High-quality work and very reliable. The project was completed exactly how we wanted. Adam was professional from start to finish and the craftsmanship exceeded our expectations.",
    name: "Sarah M.",
    location: "Johnston, IA",
    project: "Basement Finishing",
    rating: 5,
  },
  {
    quote: "Great communication and attention to detail. Would absolutely use again. Our basement looks incredible — completely transformed the space into something we're proud of.",
    name: "Mike & Linda T.",
    location: "Des Moines, IA",
    project: "Basement Remodel",
    rating: 5,
  },
  {
    quote: "Professional, efficient, and the results exceeded expectations. The bathroom remodel was done on time and on budget. Couldn't be happier with the outcome.",
    name: "James R.",
    location: "Ankeny, IA",
    project: "Bathroom Remodeling",
    rating: 5,
  },
  {
    quote: "We hired Culp Home Improvement for a full basement finishing project. The quality of work was outstanding and Adam kept us informed every step of the way.",
    name: "David & Karen W.",
    location: "Urbandale, IA",
    project: "Basement Finishing",
    rating: 5,
  },
  {
    quote: "Honest, hardworking, and talented. Our home improvement project was handled with care and precision. Highly recommend to anyone in the Des Moines area.",
    name: "Rachel B.",
    location: "Clive, IA",
    project: "General Improvements",
    rating: 5,
  },
  {
    quote: "Adam and his team did an amazing job on our home bar. Clean work, on schedule, and the finished product is exactly what we envisioned. Truly exceptional.",
    name: "Tom & Julie H.",
    location: "West Des Moines, IA",
    project: "Home Bar",
    rating: 5,
  },
];

export default function Testimonials() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-32 relative overflow-hidden" style={{ background: '#F7F4F0' }}>
      {/* Decorative background */}
      <div
        className="absolute left-0 top-0 bottom-0 w-1/3 pointer-events-none"
        style={{ background: 'linear-gradient(90deg, rgba(184,149,106,0.04), transparent)' }}
      ></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-18">
          <div>
            <p
              className="text-[#B8956A] text-[11px] font-bold uppercase tracking-[0.22em] mb-5"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Client Reviews
            </p>
            <h2
              className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              What Homeowners<br />Are Saying
            </h2>
          </div>

          {/* Rating pill */}
          <div className="inline-flex items-center gap-4 bg-white border border-[#E8E0D8] px-7 py-4 flex-shrink-0">
            <div>
              <div className="flex gap-0.5 mb-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#B8956A] text-base"></i>
                ))}
              </div>
              <p className="text-[#999] text-[10px] uppercase tracking-widest" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Average Rating
              </p>
            </div>
            <div className="w-px h-10 bg-[#E8E0D8]"></div>
            <div>
              <p className="font-black text-3xl text-[#1A1A1A] leading-none" style={{ fontFamily: 'Montserrat, sans-serif' }}>5.0</p>
              <p className="text-[#999] text-[10px] uppercase tracking-widest mt-1" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Stars
              </p>
            </div>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-[#EDE9E3] hover:border-[#C9A87C]/40 hover:-translate-y-1.5 transition-all duration-400 flex flex-col group"
            >
              {/* Top accent */}
              <div className="h-1 w-full bg-[#B8956A] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              <div className="p-8 flex flex-col flex-1">
                {/* Stars */}
                <div className="flex gap-0.5 mb-5">
                  {[...Array(t.rating)].map((_, j) => (
                    <i key={j} className="ri-star-fill text-[#B8956A] text-sm"></i>
                  ))}
                </div>

                {/* Quote mark */}
                <i className="ri-double-quotes-l text-[#B8956A]/12 text-7xl leading-none block -mt-3 mb-1"></i>

                {/* Quote */}
                <p
                  className="text-[#555] text-base leading-relaxed flex-1 mb-7"
                  style={{ fontFamily: 'Lora, serif' }}
                >
                  {t.quote}
                </p>

                {/* Attribution */}
                <div className="flex items-center justify-between pt-5 border-t border-[#F0EDE8]">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#B8956A]/10 flex-shrink-0">
                      <i className="ri-user-fill text-[#B8956A] text-base"></i>
                    </div>
                    <div>
                      <p
                        className="font-bold text-[#1A1A1A] text-sm"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}
                      >
                        {t.name}
                      </p>
                      <p
                        className="text-[#aaa] text-xs"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}
                      >
                        {t.location}
                      </p>
                    </div>
                  </div>
                  <span
                    className="text-[#B8956A] text-[10px] font-bold uppercase tracking-widest bg-[#B8956A]/8 px-3 py-1.5"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {t.project}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA after testimonials */}
        <div className="text-center mt-16">
          <p
            className="text-[#888] text-sm mb-6"
            style={{ fontFamily: 'Lora, serif' }}
          >
            Join dozens of satisfied homeowners across the Des Moines metro area.
          </p>
          <button
            onClick={() => scrollTo('contact')}
            className="inline-flex items-center gap-3 border-2 border-[#B8956A] text-[#B8956A] hover:bg-[#B8956A] hover:text-white font-bold px-12 py-4 text-sm tracking-[0.12em] uppercase transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Start Your Project <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
